import { useTranslation } from '@hooks/useTranslation';
import { Input } from '@components/UIKit/Input/Input';
import { Select } from '@components/UIKit/Select/Select';
import { FC } from 'react';
import s from './inputsBlock.module.scss';
import { countryList } from '@helpers/helpers';
import { Info } from '../Info/Info';
interface InputsBlockLoadingProps {}
export const InputsBlockLoading: FC<InputsBlockLoadingProps> = ({}) => {
  const {
    translate: tr
  } = useTranslation();
  return <div className={s.inputsBlock} data-sentry-component="InputsBlockLoading" data-sentry-source-file="InputsBlockLoading.tsx">
            <div className={s.inputsBlock__main}>
                <div>
                    <Input placeholder={tr({
          id: 'btn.loading'
        })} name={'shortId'} onPrint={() => () => {}} value={''} description={{
          text: tr({
            id: 'public.profile.symbols'
          }),
          error: false
        }} label={<span className={s.inputsBlock__label}>
                                {tr({
            id: 'settings.page.username'
          })}
                                <Info isMobile={false} id='username' tooltip={'public.profile.validation'} />
                            </span>} data-sentry-element="Input" data-sentry-source-file="InputsBlockLoading.tsx" />
                </div>
                <Input name={'email'} disabled={true} onPrint={() => () => {}} value={''} placeholder={tr({
        id: 'btn.loading'
      })} label={tr({
        id: 'settings.page.email'
      })} data-sentry-element="Input" data-sentry-source-file="InputsBlockLoading.tsx" />
                <Input className={s.inputsBlock__input} value={''} placeholder={tr({
        id: 'btn.loading'
      })} name={'name'} onPrint={() => () => {}} label={tr({
        id: 'settings.page.name'
      })} data-sentry-element="Input" data-sentry-source-file="InputsBlockLoading.tsx" />
                <Input className={s.inputsBlock__input} placeholder={tr({
        id: 'btn.loading'
      })} value={''} name={'surname'} onPrint={() => () => {}} label={tr({
        id: 'settings.page.surname'
      })} data-sentry-element="Input" data-sentry-source-file="InputsBlockLoading.tsx" />
                <Select label={tr({
        id: 'settings.page.country'
      })} className={s.inputsBlock__select} options={countryList} name={'countrycode'} changeHandler={() => () => {}} data-sentry-element="Select" data-sentry-source-file="InputsBlockLoading.tsx" />
            </div>
        </div>;
};